<template>
  <a-drawer
:maskClosable="false"
width="35%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
:destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <!-- <a-form-model-item label="企业品牌" prop="upperId">
        <div class="form_select">
          <a-select
            show-search
            v-model="form.upperId"
            placeholder="请选择"
            option-filter-prop="children"
            :filter-option="filterOption"
          >
            <a-select-option v-for="d in userList" :key="d.id">{{ d.name }}</a-select-option>
          </a-select>
          <a-button type="primary"> 添加 </a-button>
        </div>
      </a-form-model-item> -->
      <a-form-model-item label="区域名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="联系人" prop="contacts">
        <a-input v-model="form.contacts" placeholder="请输入" :maxLength="20" />
      </a-form-model-item>
      <a-form-model-item label="联系电话" prop="mobile">
        <a-input
          oninput="value=value.replace(/[^\d]/g,'')"
          v-model="form.mobile"
          placeholder="请输入"
          :maxLength="11"
        />
      </a-form-model-item>
      <a-form-model-item label="省市区" prop="area">
        <v-distpicker
          :province="form.province"
          :city="form.city"
          :area="form.area"
          @province="onChangeProvince"
          @city="onChangeCity"
          @area="onChangeArea"
        >
        </v-distpicker>
      </a-form-model-item>
      <a-form-model-item label="分配负责点位" prop="points">
        <!-- <a-tree-select
          v-model="form.points"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="treeData"
          placeholder="请选择"
          :treeCheckable="true"
          @change="handleChange($event, index)"
          class="item"
        >
          <span slot="title" slot-scope="{ key, value }" style="color: #08c"> {{ value }} </span>
        </a-tree-select> -->
        <a-tree
          v-model="menuCheckedKeys"
          checkable
          readonly
          v-if="open"
          :expanded-keys="menuExpandedKeys"
          :auto-expand-parent="autoExpandParent"
          :tree-data="treeData"
          @check="onCheck"
          @expand="onExpandMenu"
          :replaceFields="defaultProps"
        />
        <!-- <a-input v-model="form.points" v-show="show"></a-input> -->
      </a-form-model-item>
      <a-form-model-item label="详细地址" prop="address">
        <a-input v-model="form.address" placeholder="请输入" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getObj, addObj, putObj, pointList } from '@/api/pressure/region'
import setting from '@/locales/lang/zh-CN/setting'
import areadata from '@/utils/areadata.js'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: false,
    },
    userList: {
      type: Array,
      required: false,
    },
  },
  components: {},
  data() {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系电话'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      menuExpandedKeys: [],
      menuCheckedKeys: [],
      halfCheckedKeys: [],
      autoExpandParent: false,
      submitLoading: false,
      defaultProps: {
        children: 'children',
        title: 'label',
        key: 'value',
      },
      data: [],
      formTitle: '',
      inputValue: '',
      inputValues: '',
      treeData: [],
      // 表单参数
      form: {
        id: undefined,
        address: undefined,
        area: undefined,
        city: undefined,
        contacts: undefined,
        mobile: undefined,
        name: undefined,
        province: undefined,
        remark: undefined,
        upperId: 0,
        sort: 99,
        menuCheckStrictly: true,
      },
      isShow: false,
      tags: [],
      tagslist: [],
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      dateList: [],
      inputVisible: false,
      inputVisibles: false,
      menuIds: [],
      listDate: [],
      rules: {
        upperId: [{ required: true, message: '请选择企业品牌', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: validatePhone, trigger: 'change' },
        ],
        name: [{ required: true, message: '请输入区域名称', trigger: 'blur' }],
        address: [{ required: true, message: '请输入详情地址', trigger: 'blur' }],
        area: [{ required: true, message: '请选择地址', trigger: 'blur' }],
        contacts: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
    console.log(areadata, 'areadataareadata')
    this.treeData = areadata // 所有的区域信息
    this.dateList = []
    this.treeData.forEach((v) => {
      this.dateList.push(v)
      v.children.forEach((item) => {
        this.dateList.push(item)
        item.children.forEach((items) => {
          this.dateList.push(items)
          // if (items.value == '110107') {
          //   items.disabled = true
          //   console.log('测试数据', items)
          // }
        })
      })
    })
  },
  computed: {},
  watch: {},
  methods: {
    onClose() {
       const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          that.open = false
      that.$emit('close')
        },
        onCancel() {},
      })
    },
    onExpandMenu(expandedKeys) {
      this.menuExpandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    // 获取点位地址信息
    getAddress() {
      const arr = []
      this.menuCheckedKeys.forEach((itemI) => {
        this.treeData.forEach((v) => {
          v.children.forEach((item) => {
            item.children.forEach((items) => {
              if (items.value === itemI) {
                arr.push({ province: v.label, city: item.label, area: items.label })
              }
            })
          })
        })
      })
      console.log(arr, 'arrarrarrarr')
      return arr
    },
    onCheck(checkedKeys, info) {
      console.log(info.halfCheckedKeys, '测四==checkedKeyscheckedKeys')
      const filteredArray = checkedKeys.filter((item) => item.includes('000'))
      console.log(filteredArray, 'filteredArrayfilteredArray')
      const checkedNodes = this.getCheckedNodes(checkedKeys)
      console.log(checkedNodes, 'checkedKeyscheckedKeys')
      console.log(this.form.menuCheckStrictly, 'menuCheckStrictlymenuCheckStrictly')
      if (!this.form.menuCheckStrictly) {
        let currentCheckedKeys = []
        if (this.menuCheckedKeys.checked) {
          currentCheckedKeys = currentCheckedKeys.concat(this.menuCheckedKeys.checked)
        }
        if (this.menuCheckedKeys.halfChecked) {
          currentCheckedKeys = currentCheckedKeys.concat(this.menuCheckedKeys.halfChecked)
        }
        this.menuCheckedKeys = currentCheckedKeys
      } else {
        // 半选节点
        this.halfCheckedKeys = info.halfCheckedKeys
        this.menuCheckedKeys = checkedKeys
      }
      console.log(this.menuCheckedKeys,'menuCheckedKeys')
      
      this.$forceUpdate()
      // console.log(this.halfCheckedKeys, 'halfCheckedKeys')
    },
    // 去除数据
    getDate() {
      this.treeData.forEach((v) => {
        v.disabled = false
        v.children.forEach((item) => {
          item.disabled = false
          item.children.forEach((items) => {
            items.disabled = false
          })
        })
      })
    },
    getCheckedNodes(checkedKeys) {
      const checkedNodes = []
      checkedKeys.forEach((key) => {
        const node = this.treeData.find((item) => item.key === key)
        if (node) {
          checkedNodes.push(node.title)
        }
      })
      return checkedNodes
    },
    groupByFirstThreeElements(arrays) {
      const groups = {}
      arrays.forEach((arr) => {
        const key = arr.slice(0, 3).join('-') // 将前三个元素转换为字符串并用'-'连接作为key
        if (!groups[key]) {
          groups[key] = [arr] // 初始化组
        } else {
          groups[key].push(arr) // 将数组加入到对应组
        }
      })
    },
    // showInput() {
    //   this.inputVisible = true
    //   this.$nextTick(function () {
    //     this.$refs.input.focus()
    //   })
    // },
    // showInputs() {
    //   this.inputVisibles = true
    //   this.$nextTick(function () {
    //     this.$refs.inputs.focus()
    //   })
    // },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 选择省
      onChangeProvince(e) {
      console.log(e, 'dddd点点滴')
      if (e.code) {
        this.form.province = e.value
      } else {
        this.form.province = ''
        this.form.city = ''
        this.form.area = ''
      }
    },
    // 选择市
       onChangeCity(e) {
      if (e.code) {
        this.queryParam.city = e.value
      } else {
        this.queryParam.city = ''
        this.queryParam.area = ''
      }
    },
    // 选择区
      onChangeArea(e) {
      if (e.code) {
        this.queryParam.area = e.value
      } else {
        this.queryParam.area = ''
      }
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        address: undefined,
        area: undefined,
        city: undefined,
        contacts: undefined,
        mobile: undefined,
        name: undefined,
        province: undefined,
        remark: undefined,
        upperId: 0,
        sort: 99,
        menuCheckStrictly: true,
      }
      this.getDate()
      this.tags = []
      this.tagslist = []
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.menuCheckedKeys = []
      this.reset()
      // this.open = true
      this.formTitle = '添加区域'
      setTimeout(() => {
        this.getYiAdd(undefined)
      }, 200)
    },
    init() {
      console.log('测试====')
      this.reset()
      this.open = true
      this.formTitle = '添加区域'
    },
    // 查询已有的点位
    getYiAdd(e) {
      pointList({ notRegionId: e }).then((res) => {
        console.log(res, '的点点滴滴=========')
        console.log(e, '的点点滴滴=========')
        // this.listDate = [{ province: '北京市', city: '北京市辖区', area: '东城区' }]
        this.listDate = res.data
        console.log(res.data, '的点点滴滴=========res.data')
        this.listDate.forEach((itemI) => {
          this.treeData.forEach((province) => {
            if (province.label === itemI.province) {
              province.leg = 0
              province.children.forEach((city) => {
                city.leg = 0
                if (city.label === itemI.city) {
                  city.children.forEach((area) => {
                    area.leg = 0

                    if (area.label === itemI.area) {
                      area.disabled = true
                      area.leg = 1 // Mark as disabled

                      // Check if all areas under this city are disabled
                      const allAreasDisabled = city.children.every((a) => a.disabled)
                      if (allAreasDisabled) {
                        city.disabled = true
                        city.leg = 1

                        // Check if all cities under this province are disabled
                        const allCitiesDisabled = province.children.every((c) => c.disabled)
                        if (allCitiesDisabled) {
                          province.disabled = true
                        }
                      }
                    }
                  })
                }
              })
            }
          })
        })
        this.$forceUpdate()
      })
      setTimeout(() => {
        this.open = true
      }, 0)
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      const that = this
      this.reset()
      const postId = row ? row.id : ids

      getObj(postId).then((response) => {
        console.log(response.data, 'response.data')
        response.data.menuCheckStrictly = true
        this.form = response.data
        console.log(response.data.usePoints, 'dddd点点滴')
        this.open = true
        this.formTitle = '修改区域'
        console.log(this.treeData, '顶顶顶顶')
        // this.menuCheckedKeys = response.data.usePoints
        const arr = []
        this.treeData.forEach((v) => {
          response.data.usePoints.forEach((item) => {
            if (v.label === item.province) {
              v.children.forEach((items) => {
                if (items.label === item.city) {
                  console.log(items.label, 'v.label')
                  items.children.forEach((itemP) => {
                    if (itemP.label === item.area) {
                      console.log(itemP, 'v.label')
                      console.log(item, 'v.labeitemiteml')
                      // arr.push(v.value)
                      that.menuCheckedKeys.push(itemP.value)
                      console.log(arr, 'menuCheckedKeysmenuCheckedKeys')
                    }
                  })
                }
              })
            }
          })
        })
      })
      this.getYiAdd(postId)
    },
    getQu(e) {
      console.log(this.dateList, '测试数据====')
      const arr = []
      this.dateList.forEach((v) => {
        e.forEach((item) => {
          if (v.value == item) {
            arr.push(v.label)
          }
        })
      })
      return arr
    },
    // 所有菜单节点数据
    getMenuAllCheckedKeys() {
      // 全选与半选
      return this.menuCheckedKeys.concat(this.halfCheckedKeys)
    },
    /** 提交按钮 */
    submitForm: function () {
      // console.log(this.menuCheckedKeys, '对对对对对对')
      // let array = this.getQu(this.menuCheckedKeys)
      // console.log(array, 'arrayarray')
      // let menuIds = this.getMenuAllCheckedKeys()
      // if (menuIds.length) {
      //   let array = this.getQu(menuIds)
      //   console.log(array, 'arrayarray')
      // };
      // console.log(this.menuIds, 'menuIdsmenuIdsmenuIds')

      // console.log(menuIds, 'menuIdsmenuIds')

      const points = this.getAddress()
      // if(this.form.id && points.length==0){
      //   points=this.
      // }
      // console.log(points, '测试数据===')
      if (points.length === 0 && !this.form.id) return this.$message.error('请先选择点位')
      this.form.points = points
       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.form_select {
  display: flex;
  align-items: center;
  .ant-select {
    width: 300px;
    margin-right: 20px;
  }
}
</style>